import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";
import RightBar from "../../../../../components/common/RightBar";
import RightBarMethod from "../../../../../components/common/RightBar/RightBarMethod";

import { bankDepositsTableData } from "../../../../../data/accounting";

import { Card, Col, Form, Row } from "antd";

import { FaPrint } from "react-icons/fa";

import "./BankDepositeDetails.css";

const BankDepositeDetailsRightBar = [
  RightBarMethod("Tasks", "t1", <i className="fa-solid fa-star"></i>, [
    RightBarMethod("Tenant Receipt", "1", "", "", "/accounting/receivables_payments/reciepts/tenant_receipts/new"),
    RightBarMethod("Homeowner Receipt", "2", "", "", "/accounting/receivables_payments/reciepts//HomeownerReceipt"),
    RightBarMethod("Other Receipt", "3", "", "", ""),
    RightBarMethod("Application Fee", "4", "", "", ""),
    RightBarMethod("Tenant Charge", "5", "", "", "/accounting/receivables_payments/invoices/tenantcharge"),
    RightBarMethod("Homeowner Charge", "6", "", "", "/accounting/receivables_payments/invoices/newtenantcredit"),
    RightBarMethod("Tenant Credit", "7", "", "", ""),
    RightBarMethod("Homeowner Credit", "8", "", "", "/accounting/receivables_payments/invoices/newhomeownercredit"),
    RightBarMethod("Apply Credits", "9", "", "", ""),
    RightBarMethod("Common Charge", "10", "", "", "/accounting/receivables_payments/invoices/NewCommonCharge"),
    RightBarMethod("Charge Late Fees", "11", "", "", "/accounting/receivables_payments/chargelatefees"),
    RightBarMethod("New Bank Deposit", "12", "", "", "/accounting/receivables_payments/bank_deposits/NewBankDeposit"),
  ]),
];

function BankDepositeDetails() {
  const [bankDeposite, setBankDeposite] = useState({});

  const { id } = useParams();

  useEffect(() => {
    const newObject = bankDepositsTableData.find((item) => {
      return item.id === Number(id);
    });
    setBankDeposite(newObject);
  }, []);

  return (
    <>
      <div className="bank-deposite-details">
        <Row gutter={[0, 14]}>
          <Col span={24}>
            <Row justify="space-between" align="middle">
              <Col>
                <p className="deposite-heading">ACH Deposit</p>
              </Col>
              <Col>
                <button className="print-btn">
                  <FaPrint size={16} />
                  <span>Print</span>
                </button>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Card>
              <Form
                colon={false}
                labelCol={{ span: 8 }}
                wrapperCol={{ span: 8 }}
              >
                <Form.Item label="Bank Name">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.bankName
                      : null}
                  </p>
                </Form.Item>
                <Form.Item label="Account Name">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.accountName
                      : null}
                  </p>
                </Form.Item>
                <Form.Item label="Account Number">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.accountNumber
                      : null}
                  </p>
                </Form.Item>
                <Form.Item label="Description">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.description
                      : null}
                  </p>
                </Form.Item>
                <Form.Item label="Deposit Number">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.depositNumber
                      : null}
                  </p>
                </Form.Item>
                <Form.Item label="Deposit Date">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.depositDate
                      : null}
                  </p>
                </Form.Item>
                <Form.Item label="Submission Date">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.submissionDate
                      : null}
                  </p>
                </Form.Item>
                <Form.Item label="Number of Items">
                  <p>
                    {bankDeposite?.deposit
                      ? bankDeposite.deposit.numberofItems
                      : null}
                  </p>
                </Form.Item>
              </Form>
            </Card>
          </Col>
          <Col span={24}>
            <Row className="header-row">
              <Col span={2}>
                <span>Reference</span>
              </Col>
              <Col span={2}>
                <span>Date</span>
              </Col>
              <Col span={7}>
                <span>Property</span>
              </Col>
              <Col span={3}>
                <span>From</span>
              </Col>
              <Col span={7}>
                <span>Description</span>
              </Col>
              <Col span={3}>
                <span>Amount</span>
              </Col>
            </Row>
            {bankDeposite?.depositItems
              ? bankDeposite.depositItems.map((item, index) => {
                  return (
                    <Row className="data-row" key={index}>
                      <Col span={2}>
                        <span>{item.reference}</span>
                      </Col>
                      <Col span={2}>
                        <span>{item.date}</span>
                      </Col>
                      <Col span={7}>
                        <span>{item.property}</span>
                      </Col>
                      <Col span={3}>
                        <span>{item.from}</span>
                      </Col>
                      <Col span={7}>
                        <span>{item.description}</span>
                      </Col>
                      <Col span={3}>
                        <span>{item.amount}</span>
                      </Col>
                    </Row>
                  );
                })
              : null}
          </Col>
          <Col span={24}>
            <Card title="Activity">
              <div className="activity">
                <p>03/07/2023 06:01 AM</p>
                <p>
                  <strong>Created</strong> – System
                </p>
              </div>
            </Card>
          </Col>
          <Col span={24}>
            {/* <AttachmentsUpload /> */}
          </Col>
        </Row>
      </div>
      <div className="RightSidebar">
        <RightBar RightBarData={BankDepositeDetailsRightBar} />
      </div>
    </>
  );
}

export default BankDepositeDetails;
